/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { ref } from 'vue';
import { Store } from 'vuex';
import { Tuple } from '../../../expression/domain/tuple';
import HelperLoading from '../../../../../common/infrastructure/funciones/HelperLoading';
import MessageService, { MessageType } from '../../../../../common/infrastructure/servicios/MessageService';
import HelperCommon from '../../../../../common/infrastructure/funciones/HelperCommon';
import { clave } from '../../../dataupdate/domain/clave';
import HelperUtils, { newGuid } from '../../../../../common/infrastructure/funciones/HelperUtils';

export default function multiTab (store:any) {
    
    const newKeys = ref<Tuple<any,number,number,number>>()
    let itemTabs = ref<Tuple<any,number,number,number>[]>([]);
    let activeId = ref('');
    let selectedTab = ref(0);


    const changeTab = (event: any) => {

        const index = event.index;

        navigateTab(index);
    }
    const navigateTab = (index: number) => {
        selectedTab.value = index;
    }

    const getMaxTabs = () => {
       /*
        const key = store.getters.getKey(ConfigurationConst.NUMMAXTABSOPORTUNIDADES);
        if (key) {
            const converter = HelperCommon.toNumber(key);
            if (converter > 0) {
                return converter;
            }
        }
    */
        return 6;


    }
    const findTab = (key: any | null) => {
        if (itemTabs.value) {
            return itemTabs.value.findIndex(x => x.key == key);
        }
        return -1;
    }

    const addTab = (id: string, applicationId:number, applicationVersion:number, componentId:number ) => {
        HelperLoading.showLoading();
        const key = id ?? newGuid();
        var pos = findTab(id);
        if (pos != -1) {
            HelperLoading.hideLoading();
            navigateTab(pos);
            //if (params && params.length > 0){
                newKeys.value={
                    key: key,
                    value:applicationId,
                    value1:applicationVersion,
                    value2:componentId
                  
                } as any ;
            //}
            
            return;
        }
        const contador = itemTabs.value ? itemTabs.value.length + 1 : 1;
        if (contador > getMaxTabs()) {
            MessageService.showMessage(MessageType.Aviso, '', 'Se ha superado el número máximo de pestañas abiertas.');
            HelperLoading.hideLoading();
            return;
        }
        const data: Tuple<any,number,number,number> = {
            key: key,
            value:applicationId,
            value1:applicationVersion,
            value2:componentId
        };

        if (contador == 1) {
            itemTabs.value = [data];
        }
        else {
            itemTabs.value?.push(data);
        }
        activeId.value = key;
        navigateTab(contador - 1);
        HelperLoading.hideLoading();

    }

    const redirectToActionPage = (rfp: any, withLock: boolean) => {
        /*
        HelperLoading.showLoading();
        const user = store.getters.currentUser;
        const sessionId = store.getters.sessionID;

        if (rfp == null) {
            return;
        }

        if (withLock) {
            if (HelperRfp.checkLock(user, rfp)) {
                HelperLoading.hideLoading();
                return;
            }
        }
        HelperRfp.GetRfp(sessionId, rfp.id).then((_rfp) => {

            if (_rfp) {
                if (_rfp.status.id == rfpStatusTypeConst.hibernada) {
                    HelperRfp.rollbackRFPStatus(sessionId, rfp.id, rfpStatusType.pte_tarificar, rfpData.items).then((resp) => {
                        if (resp) {
                            MessageService.showToast(MessageType.Correcto, '', 'La solicitud ' + rfp.reference + ' ha dejado de estar hibernada');
                        }
                    })
                }
                else {

                    if (withLock) {
                        HelperRfp.LockRfp(sessionId, user, _rfp.id, _rfp, rfpData.items).then((data) => {
                            if (data) {
                                doActionTab(data);
                            }
                        });
                    }
                    else {
                        doActionTab(_rfp);
                    }
                }

            }
        }).finally(() => {
            HelperLoading.hideLoading();
        })
*/
    }

    const formatTabLabel = (rfp: any) => {
      
      /*  if (rfp) {
            const entities = rfp.entities;
            let outName = '';
            var policyHolder = entities?.filter(e => e.role.id == RoleConst.TOMADOR);
            if (policyHolder && policyHolder.length > 0) {
                outName += policyHolder[0].documentId ?? '';
            }

            outName += ' - ' + rfp.product.name;

            return outName;
        }
        */

        return '';
    }

    

  

    const doActionTab = (keys: clave[], params = []) => {                        
        const id = keys.find(x=> x !== undefined)?.value?.toString() ?? '';//  JSON.stringify(keys.map(x=> x.campo + x.valor))
        // TODO
        //addTab(id, tabla,'...',tabla, params,'','');
    }

    const closeTab = (id:string): Promise<boolean> => {
        return new Promise<boolean>((resolve, reject) => {


            
            if (itemTabs.value) {

                itemTabs.value = HelperUtils.RemoveObjectById(id, itemTabs.value);
                        selectedTab.value -= 1;
                        HelperLoading.hideLoading();
                        if (selectedTab.value <= 0) {
                            selectedTab.value = 0;
                        }
                        resolve(true);

            }
        })
    }

    const closeAllTabs = () => {
        if (itemTabs.value) {
            itemTabs.value.forEach(x => {
                closeTab(x.key)
            })
        }
    }

  return {    
    itemTabs,
    activeId,
    selectedTab,
    changeTab,
    navigateTab,
    doActionTab,    
    formatTabLabel,
    redirectToActionPage,
    addTab,
    findTab,
    closeAllTabs,
    closeTab,
    newKeys
  }
}
